import React from 'react';
import './Calc.css';

class Calc extends React.Component {
    constructor(props) {
        super(props);
        let date = new Date();
        this.state = {
            'date' : date.toLocaleDateString(),
            'allRates' : {},
            'currectBTC' : false,
        };
        this.getAllRate();

    }
    getAllRate = () => {
        const url = `https://api.privatbank.ua/p24api/pubinfo?json&exchange&coursid=4`;
        const url1 = `https://api.privatbank.ua/p24api/pubinfo?json&exchange&coursid=5`;
        fetch(url, {
            method: 'GET',
        })
            .then(data => {
                return data.json()
            })
            .then(data => {
                fetch(url1, {
                    method: 'GET',
                })
                    .then(data1 => {
                        return data1.json()
                    })
                    .then(data1 => {
                        for (let i = 0; i < data1.length-1; i++) {
                            data.push(data1[i]);
                        }
                        this.setState({allRates : data});
                    })
                    .catch(() => console.log("Can’t access " + url + " response. Blocked by browser?"))
            })
            .catch(() => console.log("Can’t access " + url + " response. Blocked by browser?"))
    };
    convert = (e) => {
        e.preventDefault();
        let sale = e.target.elements.saleCourse.value;
        let buy = e.target.elements.buyCourse.value;
        let value = e.target.elements.value.value;
        let result = 0;
        console.log(value)
        if (value === '') {
            alert('Будь ласка, введіть коректну кількість валюти')
        } else if (value === '0') {
            alert('Будь ласка, введіть коректну кількість валюти (>0)')
        };
        if (!this.state.currectBTC) {
            e.target.elements.saleCourse.children['BTC'].value = e.target.elements.saleCourse.children['BTC'].value * e.target.elements.saleCourse.children['USD'].value;
            e.target.elements.buyCourse.children['BTC'].value = e.target.elements.buyCourse.children['BTC'].value * e.target.elements.buyCourse.children['USD'].value;
            this.setState({currectBTC : true})
        }
        if (sale > buy) {
            result = value / buy * sale;
        } else {
            result = value * sale / buy;
        }
        e.target.elements.result.value = result.toFixed(2);
    };
    currectBTC = () => {

    };
    render() {
        return (
            <form className="col-xl-9 converter-block lite-shadow" onSubmit={this.convert}>
                <div className="inputs d-flex justify-content-between w-100">
                    <div className="input">
                        <h4 className="input-title">Міняю:</h4>
                        <div className="form">
                            <input type="number" className="input-main blue-input" placeholder="1000" name="value"/>
                            <div className="input-button blue-btn">
                                <select className="customSel" name="saleCourse">
                                    <option value='1' >UAN</option>
                                    {Object.keys(this.state.allRates).map( (keyName1, i) => (
                                        <option key={keyName1} name={this.state.allRates[keyName1]['ccy']} value={this.state.allRates[keyName1]['sale']}> {this.state.allRates[keyName1]['ccy']}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="input">
                        <h4 className="input-title">Отримую:</h4>
                        <div className="form"><input name='result' type='number' className="input-main orange-input" placeholder="1000" readOnly={true}/>
                            <div className="input-button orange-btn">
                                <select className="customSel" name="buyCourse">
                                    <option value='1' >UAN</option>
                                    {Object.keys(this.state.allRates).map( (keyName, i) => (
                                        <option key={keyName} name={this.state.allRates[keyName]['ccy']} value={this.state.allRates[keyName]['buy']}> {this.state.allRates[keyName]['ccy']}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <button type='submit' className="convert-button">Розрахувати</button>
            </form>
        )
    }
}

export default Calc;